/* 🤖 this file was generated by script */
export const wiconEyeSend = {
  name: 'eye_send',
  data: `<svg viewBox="0 0 20 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.03 5.76A3 3 0 009 11.02a3 3 0 001.97-5.26m-3.94 0A8.19 8.19 0 019 5.5c.62 0 1.3.09 1.97.26m-3.94 0C4.86 6.31 2.67 7.67 2 9.5c.5 1.4 1.9 2.52 3.5 3.22m5.47-6.96c1.07.27 3.03.74 5.53 2.74"/><path fill="none" stroke="currentColor" stroke-linecap="round" d="M8.74 13.92h9.5m0 0l-2.03-2.03m2.03 2.03l-2.03 2.03"/></svg>`,
};
